import Vue from 'vue'
import Vuex from 'vuex'

import language from './store/language'
import building from './store/building'
import entrance from './store/entrance'
import floor from './store/floor'
import apartment from './store/apartment'
import parking from './store/parking'
import gallery from './store/gallery'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showCoreDrawer: true,
    layout: 'blank-layout'
  },
  mutations: {
    TOGGLE_CORE_DRAWER (state) {
      state.showCoreDrawer = !state.showCoreDrawer
    },
    SET_LAYOUT (state, layout) {
      state.layout = layout
    }
  },
  getters: {
    layout (state) {
      return state.layout
    }
  },
  modules: {
    building,
    entrance,
    language,
    floor,
    apartment,
    parking,
    gallery
  }
})
